module.exports = __webpack_public_path__ + "static/media/google.417b1827.png";